module.exports = __webpack_public_path__ + "static/media/dimigo-background.0991d2d3.svg";